// src/components/auth/LoginSuccess.jsx
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { jwtDecode } from 'jwt-decode'; // Changed import

const LoginSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  
  useEffect(() => {
    // Token is delivered via URL fragment (#token=...) to keep it out of
    // server logs and browser history. Fall back to query param for
    // backwards compatibility during deployment.
    const hash = window.location.hash;
    const token = hash.startsWith('#token=')
      ? hash.slice(7)
      : searchParams.get('token');

    // Scrub the token from the URL immediately so it doesn't sit in history
    window.history.replaceState({}, '', window.location.pathname);

    if (token) {
      const decodedToken = jwtDecode(token);
      login(token, decodedToken);
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [searchParams, login, navigate]);

  // Show loading state while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <div className="flex items-center space-x-3">
          <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-gray-600">Logging you in...</p>
        </div>
      </div>
    </div>
  );
};

export default LoginSuccess;
